import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';
import { useDeleteAssetMutation } from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import { ModalProps } from '../../../types/modal';
import { Experience } from '../../../types/experience';
import toast from '../../../shared/Toast';

interface DeleteExperienceModalProps extends ModalProps {
    experience: Experience;
    onDelete?: () => void;
}

const DeleteExperienceModal = ({
    open,
    onClose,
    experience,
    onDelete,
}: DeleteExperienceModalProps) => {
    const loggedInUser = UserRole();
    const [deleteAsset, { isLoading }] = useDeleteAssetMutation();

    const isDraft = experience.status === 'draft';
    const displayName = experience.name?.trim()
        ? experience.name
        : isDraft
          ? 'this draft'
          : 'this listing';

    const handleDelete = async () => {
        if (!loggedInUser?.company) return;

        try {
            await deleteAsset([loggedInUser.company, experience.id]).unwrap();
            toast.success('Listing has been deleted');
            onClose();
            onDelete?.();
        } catch (error: any) {
            toast.error(
                error?.data?.message ??
                    'Failed to delete listing. Cannot delete an experience with reservations',
            );
        }
    };

    return (
        <Dialog open={open} onClose={isLoading ? undefined : onClose}>
            <DialogTitle>
                {isDraft ? 'Delete Draft' : 'Delete Listing'}
            </DialogTitle>
            <DialogContent>
                <Stack spacing={1}>
                    <Typography>
                        Are you sure you want to delete <b>{displayName}</b>?
                    </Typography>
                    <Alert severity='warning'>
                        This action cannot be undone
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='outlined'
                    onClick={onClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    color='error'
                    onClick={handleDelete}
                    disabled={isLoading}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteExperienceModal;
